import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  AifApproverAccess,
  getAIFApproverList,
  getAmcApproverAccess,
  UpdateAifApprover,
} from '../../redux-store/actions/userManagement';
import { AddAifApproverRequestBody, AifApprover } from '../../redux-store/types/api-types';
import { ColumnType } from '../DataTable';
import { useHistory } from 'react-router';
import UserMgmtListPage, {
  NameLinkCell,
  buildAccessColumn,
  buildActionsColumn,
  formatPhone,
  formatUserName,
  matchesUserSearch,
} from './UserMgmtListPage';

function aifApprover(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [accessForEditAdd, setAccessForEditAdd] = useState(false);

  return (
    <UserMgmtListPage<AifApprover>
      loadData={async () => {
        const res = (await dispatch(getAIFApproverList())) as unknown as AifApprover[];
        const access = (await dispatch(getAmcApproverAccess())) as unknown as AifApproverAccess;
        setAccessForEditAdd(access.amcApproverAccess);
        return res || [];
      }}
      searchPlaceholder="Search for AIF Approvers"
      inviteLabel="Add AIF Approver"
      showInvite={accessForEditAdd}
      onInvite={() => history.push('add-aif-approver')}
      accessDisabled={!accessForEditAdd}
      filterRow={(row, q) =>
        matchesUserSearch(q, [
          formatUserName(row.user),
          row.user?.email,
          `${row.user?.countryCode || ''}${row.user?.phone || ''}`,
        ])
      }
      getColumns={({ onToggleAccess, accessDisabled }) => {
        const columns: ColumnType[] = [
          {
            header: 'Name',
            align: 'left',
            headerAlign: 'left',
            renderCell: (row: AifApprover) => (
              <NameLinkCell
                label={formatUserName(row.user)}
                to={{ pathname: 'aif-approver-details', state: { aifApproverId: row.id } }}
              />
            ),
          },
          {
            header: 'Email Id',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: AifApprover) => row.user.email || 'N/A',
          },
          {
            header: 'Mobile number',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: AifApprover) => formatPhone(row.user),
          },
          buildAccessColumn(onToggleAccess, accessDisabled),
          buildActionsColumn((row: AifApprover) => [
            {
              label: 'View Details',
              icon: '/images/view-application.svg',
              to: { pathname: 'aif-approver-details', state: { aifApproverId: row.id } },
            },
          ]),
        ];
        return columns;
      }}
      onAccessChange={async (row, nextActive) =>
        (await dispatch(
          UpdateAifApprover(row.id as number, {
            ...(row as unknown as AddAifApproverRequestBody),
            isActive: nextActive,
          })
        )) as unknown as AifApprover
      }
    />
  );
}

export default aifApprover;
